import type {ErrorProcessor} from '../types'

const nginxBadResponses = ['Forbidden', 'Service unavailable', 'Bad Gateway']

export const processUnhandledRejection: ErrorProcessor = (error, scope) => {
  const findWords = (words: string[], predicate?: 'every' | 'some') =>
    words[predicate || 'every'](w => error.message.toLowerCase().includes(w))

  if (findWords(['internal', 'error']) && findWords(['500', 'server'], 'some')) {
    return scope.updateError({level: 'critical'})
  }

  if (
    findWords(['access', 'denied']) ||
    findWords(['network', 'offline', 'unloaded']) ||
    nginxBadResponses.some(r => error.message === `Unhandled rejection: ${r}`)
  ) {
    return scope.updateError({level: Ya.Rum.ERROR_LEVEL.INFO})
  }

  return error
}
